import styled from 'styled-components';

const S = {};
S.LoaderWrapper = styled.div`
`;

export default S;